'use client';
import type { ReactElement } from 'react';
import { useContext } from 'react';
import type { EdgeProps } from '@xyflow/react';
import type { MindmapFlowEdge } from './mindmap-types';
import { MindmapInteractionContext } from './mindmap-interaction-context';
import { getMindmapEdgeModel } from './mindmap-edge-model';
import { useMindmapEdgeEntranceStart } from './useMindmapEdgeEntranceStart';
export function MindmapEdge({ id, source, sourceX, sourceY, target, targetX, targetY, sourcePosition, targetPosition, data, }: EdgeProps<MindmapFlowEdge>): ReactElement {
    const { hoveredNodeId, highlightedNodeIds, isEntranceComplete } = useContext(MindmapInteractionContext);
    const didEntranceStart = useMindmapEdgeEntranceStart({
        edgeId: id,
        isEntranceComplete,
    });
    const edgeModel = getMindmapEdgeModel({
        sourceNodeId: source,
        targetNodeId: target,
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        edgeData: data,
        hoveredNodeId,
        highlightedNodeIds,
        didEntranceStart,
        isEntranceComplete,
    });
    return (
      <g style={edgeModel.groupStyle}>
        <path d={edgeModel.path} fill="none" stroke={edgeModel.strokeColor} strokeWidth={1.5} strokeLinecap="round"/>
      </g>
    );
}
